import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';
import type {RootState} from '@/store';

export interface FormMakerPublishState {
  shareableUrl: string;
  isPublishedLink: boolean;
  isPublishedPopup: boolean;
  isPublishedEmbeddedForm: boolean;
  popupDelay: number;
  shortPopupDelay: number;
  longPopupDelay: number;
  popupHtmlContent: string;
  iframePopupHtmlContent: string;
  embeddedFormHtmlContent: string;
  isSharedInTeam: boolean;
}

const initialState: FormMakerPublishState = {
  shareableUrl: '',
  isPublishedLink: false,
  isPublishedPopup: false,
  isPublishedEmbeddedForm: false,
  popupDelay: 0,
  shortPopupDelay: 0,
  longPopupDelay: 0,
  popupHtmlContent: '',
  iframePopupHtmlContent: '',
  embeddedFormHtmlContent: '',
  isSharedInTeam: false,
};

const formMakerPublishStateSlice = createSlice({
  name: 'formMakerPublishState',
  initialState,
  reducers: {
    setFormMakerPublishState: (_state, action: PayloadAction<FormMakerPublishState>) => {
      return action.payload;
    },
    setIsPublishedLink: (state, action: PayloadAction<boolean>) => {
      state.isPublishedLink = action.payload;
    },
    setIsPublishedPopup: (state, action: PayloadAction<boolean>) => {
      state.isPublishedPopup = action.payload;
    },
    setIsPublishedEmbeddedForm: (state, action: PayloadAction<boolean>) => {
      state.isPublishedEmbeddedForm = action.payload;
    },
    setIsSharedInTeam: (state, action: PayloadAction<boolean>) => {
      state.isSharedInTeam = action.payload;
    },
    setPopupDelay: (state, action: PayloadAction<number>) => {
      state.popupDelay = action.payload;
    },
    unpublishAllChannels: (state) => {
      state.isPublishedLink = false;
      state.isPublishedPopup = false;
      state.isPublishedEmbeddedForm = false;
    },
  },
});

export const {setFormMakerPublishState, setIsPublishedLink, setIsPublishedPopup, setIsPublishedEmbeddedForm, setIsSharedInTeam, setPopupDelay, unpublishAllChannels} =
  formMakerPublishStateSlice.actions;

export const formMakerPublishStateReducer = formMakerPublishStateSlice.reducer;

export const selectFormMakerPublishState = (state: RootState): FormMakerPublishState => state.formMakerPublishState;
